'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purchaseMap = exports.deleteCard = exports.editCard = exports.createCard = exports.getCharges = exports.setDefaultSource = exports.getCustomer = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCustomer = exports.getCustomer = function getCustomer(f) {
  return (0, _callApi2.default)('GET', '/account/customer');
};
var setDefaultSource = exports.setDefaultSource = function setDefaultSource(id) {
  return (0, _callApi2.default)('PUT', '/account/source/make-default', { id: id }, 'application/json');
};
var getCharges = exports.getCharges = function getCharges(settings) {
  return (0, _callApi2.default)('POST', '/account/charges', settings, 'application/json');
};
var createCard = exports.createCard = function createCard(card) {
  return (0, _callApi2.default)('POST', '/account/source', card, 'application/json');
};
var editCard = exports.editCard = function editCard(card) {
  return (0, _callApi2.default)('PUT', '/account/source', card, 'application/json');
};
var deleteCard = exports.deleteCard = function deleteCard(card) {
  return (0, _callApi2.default)('DELETE', '/account/source', card, 'application/json');
};
var purchaseMap = exports.purchaseMap = function purchaseMap(map) {
  return (0, _callApi2.default)('POST', '/account/purchase/map', map, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/account.js
// module id = 721
// module chunks = 0